<template>
  <div class="container mt-3">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Titolo</th>
          <th scope="col">TLDR</th>
          <th scope="col">Team</th>
          <th scope="col">Visibilita'</th>
          <th scope="col">Ultimo Aggiornamento</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="project in projects">
          <th scope="row">{{ project.title }}</th>
          <td>{{ project.tldr }}</td>
          <td>{{ project.team.name }}</td>
          <td v-if="project.isPrivate">Privato</td>
          <td v-else>Pubblico</td>
          <td>{{ project.lastUpdate }}</td>
          <td><router-link :to="{ name: 'UserProjectDetail', params: { id: project.id } }" class="nav-link">Info</router-link></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { database } from '@/firebase'
import { convertDate } from '@/helpers'

export default {
  name: 'AdminProjectList',
  data() {
    return {
      projects: []
    }
  },
  created() {
    database.collection("Projects").onSnapshot(snap => {
      this.projects = [];
      snap.forEach(doc => {
        let project;
        project = doc.data()
        project.id = doc.id
        console.log(project)
        project.lastUpdate = convertDate(project.lastUpdate)

        project.team.get()
        .then(resolve => {
          project.team = resolve.data().name
          this.projects.push(project)
        })
      })
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/AdminProjectList.vue